module.exports = __webpack_public_path__ + "./fonts/Cursive-Regular.ttf";